<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="ProgramDetails.saveError">
    <template slot="center">
      <el-form
         label-width="20em"
         label-position="right"
        :ref="formRef"
        :model="formData">

        <!-- TRANSITION_PROGRAM_ACCEPT, -->
        <!-- TRANSITION_PROGRAM_MARK_AS_READY, -->
        <!-- TRANSITION_PROGRAM_MARK_AS_DRAFT, -->
        <!-- TRANSITION_PROGRAM_ACTIVATE, -->
        <!-- TRANSITION_PROGRAM_PUT_ON_HOLD, -->
        <!-- TRANSITION_PROGRAM_REACTIVATE, -->
        <!-- TRANSITION_PROGRAM_CANCEL, -->

        <el-collapse v-model="options.selectedTransition" accordion>

          <template v-if="isAssigned">
            <el-collapse-item
               v-if="_includes(options.availableTransitions, TRANSITION_PROGRAM.TRANSITION_PROGRAM_ACTIVATE)"
              :title="$t('label.activate_program')"
              :name="TRANSITION_PROGRAM.TRANSITION_PROGRAM_ACTIVATE">
              <section>
                <div class="section-items is-small-padding">

                  <el-form-item
                     prop="start_date"
                    :label="$t('label.start_date')">
                    <el-date-picker
                       v-model="formData.start_date"
                       type="date"
                       format="dd/MM/yyyy"
                       value-format="yyyy-MM-dd"
                      :disabled="!edit"
                      :picker-options="options.start_date">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item
                     prop="end_date"
                    :label="$t('label.end_date')">
                    <el-date-picker
                      :value="endDate"
                      disabled
                      type="date"
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item :label="$t('label.notify_participant')">
                    <el-switch v-model="formData.send_notification" :disabled="!edit"></el-switch>
                  </el-form-item>

                  <template v-if="formData.send_notification">
                    <el-form-item :label="$t('label.include_pdf')">
                      <el-checkbox-group v-model="formData.include_pdf" :disabled="!edit">
                        <el-checkbox label="list">{{ $t('label.schedules_list') }}</el-checkbox>
                        <el-checkbox label="calendar">{{ $t('label.schedules_calendar') }}</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>

                    <el-form-item :label="$t('label.message')" prop="message">
                      <el-col class="el-col--min-25em" :span="16">
                        <el-input
                           type="textarea"
                           v-model="formData.message"
                          :disabled="!edit"
                          :autosize="{ minRows: 3, maxRows: 5 }">
                        </el-input>
                      </el-col>
                    </el-form-item>
                  </template>

                  <hr>

                  <el-form-item>
                    <el-col class="el-col--min-25em" :span="16">
                      <el-button
                         type="success"
                         class="w-100 is-icon"
                        :disabled="!edit"
                        :loading="_get(ProgramDetails, 'saving')"
                        @click="startTransitionActivatePayload(TRANSITION_PROGRAM.TRANSITION_PROGRAM_ACTIVATE)">
                        {{ $t('label.activate') }}
                      </el-button>
                    </el-col>
                  </el-form-item>

                </div>
                <!-- end ~ section-items -->

                <div class="section-help">
                  <p v-html="_markdown.render($t('label.transition_program_assigned_active_help'))"></p>
                </div>

              </section>
            </el-collapse-item>

            <el-collapse-item
               v-if="_includes(options.availableTransitions, TRANSITION_PROGRAM.TRANSITION_PROGRAM_ACTIVATE_SEND_NOTIFICATION)"
              :title="$t('label.active_program')"
              :name="TRANSITION_PROGRAM.TRANSITION_PROGRAM_ACTIVATE_SEND_NOTIFICATION">
              <section>
                <div class="section-items is-small-padding">

                  <el-form-item :label="$t('label.include_pdf')">
                    <el-checkbox-group v-model="formData.include_pdf" :disabled="!edit">
                      <el-checkbox label="list">{{ $t('label.schedules_list') }}</el-checkbox>
                      <el-checkbox label="calendar">{{ $t('label.schedules_calendar') }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>

                  <el-form-item :label="$t('label.message')" prop="message">
                    <el-col class="el-col--min-25em" :span="16">
                      <el-input
                         type="textarea"
                         v-model="formData.message"
                        :disabled="!edit"
                        :autosize="{ minRows: 3, maxRows: 5 }">
                      </el-input>
                    </el-col>
                  </el-form-item>

                  <hr>

                  <el-form-item>
                    <el-col class="el-col--min-25em" :span="16">
                      <el-button
                         type="success"
                         class="w-100 is-icon"
                         icon="fas fa-paper-plane"
                        :disabled="!edit"
                        :loading="_get(ProgramDetails, 'saving')"
                        @click="sendActiveProgramNotification">
                        {{ $t('label.notify_participant') }}
                      </el-button>
                    </el-col>
                  </el-form-item>

                </div>

                <div class="section-help">
                  <p v-html="_markdown.render($t('label.notify_participant_help'))"></p>
                </div>

              </section>
            </el-collapse-item>


            <el-collapse-item
               v-if="_includes(options.availableTransitions, TRANSITION_PROGRAM.TRANSITION_PROGRAM_PUT_ON_HOLD)"
              :title="$t('label.put_on_hold')"
              :name="TRANSITION_PROGRAM.TRANSITION_PROGRAM_PUT_ON_HOLD">
              <section>
                <div class="section-items is-small-padding">
                  <el-form-item :label="$t('label.notify_participant')">
                    <el-switch v-model="formData.send_notification" :disabled="!edit"></el-switch>
                  </el-form-item>

                  <template v-if="formData.send_notification">
                    <el-form-item :label="$t('label.message')" prop="message">
                      <el-col class="el-col--min-25em" :span="16">
                        <el-input
                           type="textarea"
                           v-model="formData.message"
                          :disabled="!edit"
                          :autosize="{ minRows: 3, maxRows: 5 }">
                        </el-input>
                      </el-col>
                    </el-form-item>
                  </template>

                  <hr>

                  <el-form-item>
                    <el-col class="el-col--min-25em" :span="16">
                      <el-button
                         type="warning"
                         class="w-100 is-icon"
                        :disabled="!edit"
                        :loading="_get(ProgramDetails, 'saving')"
                        @click="startTransitionNotificationPayload(TRANSITION_PROGRAM.TRANSITION_PROGRAM_PUT_ON_HOLD)">
                        {{ $t('label.put_on_hold') }}
                      </el-button>
                    </el-col>
                  </el-form-item>

                </div>

                <div class="section-help">
                  <p v-html="_markdown.render($t('label.transition_program_assigned_on_hold_help'))"></p>
                </div>

              </section>
            </el-collapse-item>

            <el-collapse-item
               v-if="_includes(options.availableTransitions, TRANSITION_PROGRAM.TRANSITION_PROGRAM_REACTIVATE)"
              :title="$t('label.reactivate')"
              :name="TRANSITION_PROGRAM.TRANSITION_PROGRAM_REACTIVATE">
              <section>
                <div class="section-items is-small-padding">
                  <el-form-item :label="$t('label.notify_participant')">
                    <el-switch v-model="formData.send_notification" :disabled="!edit"></el-switch>
                  </el-form-item>

                  <template v-if="formData.send_notification">
                    <el-form-item :label="$t('label.message')" prop="message">
                      <el-col class="el-col--min-25em" :span="16">
                        <el-input
                           type="textarea"
                           v-model="formData.message"
                          :disabled="!edit"
                          :autosize="{ minRows: 3, maxRows: 5 }">
                        </el-input>
                      </el-col>
                    </el-form-item>
                  </template>

                  <hr>

                  <el-form-item>
                    <el-col class="el-col--min-25em" :span="16">
                      <el-button
                         type="success"
                         class="w-100 is-icon"
                        :disabled="!edit"
                        :loading="_get(ProgramDetails, 'saving')"
                        @click="startTransitionNotificationPayload(TRANSITION_PROGRAM.TRANSITION_PROGRAM_REACTIVATE)">
                        {{ $t('label.reactivate') }}
                      </el-button>
                    </el-col>
                  </el-form-item>

                </div>

                <div class="section-help">
                  <p v-html="_markdown.render($t('label.transition_program_assigned_reactivate_help'))"></p>
                </div>

              </section>
            </el-collapse-item>

            <el-collapse-item
               v-if="_includes(options.availableTransitions, TRANSITION_PROGRAM.TRANSITION_PROGRAM_CANCEL)"
              :title="$t('label.cancel_program')"
              :name="TRANSITION_PROGRAM.TRANSITION_PROGRAM_CANCEL">
              <section>
                <div class="section-items is-small-padding">
                  <el-form-item :label="$t('label.notify_participant')">
                    <el-switch v-model="formData.send_notification" :disabled="!edit"></el-switch>
                  </el-form-item>

                  <template v-if="formData.send_notification">
                    <el-form-item :label="$t('label.message')" prop="message">
                      <el-col class="el-col--min-25em" :span="16">
                        <el-input
                           type="textarea"
                           v-model="formData.message"
                          :disabled="!edit"
                          :autosize="{ minRows: 3, maxRows: 5 }">
                        </el-input>
                      </el-col>
                    </el-form-item>
                  </template>

                  <hr>

                  <el-form-item>
                    <el-col class="el-col--min-25em" :span="16">
                      <permissions-control-wrapper
                         action="label.cancel_program"
                        :required-general="$PERMISSIONS_GENERAL.CANCEL"
                        :permissions="_get(ProgramDetails, 'meta.permissions')">
                        <el-button
                           slot="allowed"
                           type="danger"
                           class="w-100"
                          :disabled="!edit"
                          :loading="_get(ProgramDetails, 'saving')"
                          @click="startTransitionNotificationPayload(TRANSITION_PROGRAM.TRANSITION_PROGRAM_CANCEL)">
                          {{ $t('label.cancel') }}
                        </el-button>
                        <el-button
                           slot="not-allowed"
                           type="info"
                           class="w-100 is-icon"
                           icon="far fa-lock-alt"
                          :disabled="!edit">
                          {{ $t('label.cancel') }}
                        </el-button>
                      </permissions-control-wrapper>
                    </el-col>
                  </el-form-item>

                </div>

                <div class="section-help">
                  <p v-html="_markdown.render($t('label.transition_program_assigned_cancel_help'))"></p>
                </div>

              </section>
            </el-collapse-item>

            <el-collapse-item
               v-if="_includes(options.availableTransitions, TRANSITION_PROGRAM.TRANSITION_PROGRAM_IS_CANCELED)"
              :title="$t('label.canceled')"
              :name="TRANSITION_PROGRAM.TRANSITION_PROGRAM_IS_CANCELED">
              <section>
                <div class="section-items is-small-padding">

                  <el-form-item
                     prop="start_date"
                    :label="$t('label.start_date')">
                    <el-date-picker
                       v-model="formData.start_date"
                       type="date"
                       format="dd/MM/yyyy"
                       value-format="yyyy-MM-dd"
                      :disabled="!edit"
                      :picker-options="options.start_date">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item
                     prop="end_date"
                    :label="$t('label.end_date')">
                    <el-date-picker
                      :value="endDate"
                      disabled
                      type="date"
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item>
                    <el-col class="el-col--min-25em" :span="16">
                      <el-button
                         type="info"
                         class="w-100 is-icon"
                         icon="far fa-ban"
                        :disabled="true">
                        {{ $t('label.canceled') }}
                      </el-button>
                    </el-col>
                  </el-form-item>

                </div>

                <div class="section-help">
                  <p v-html="_markdown.render($t('label.status_program_assigned_canceled_help'))"></p>
                </div>

              </section>
            </el-collapse-item>

          </template>
          <!-- end ~ is assigned -->

          <template v-else>

            <el-collapse-item
               v-if="_includes(options.availableTransitions, TRANSITION_PROGRAM.TRANSITION_PROGRAM_MARK_AS_READY)"
              :title="$t('label.change_status')"
              :name="TRANSITION_PROGRAM.TRANSITION_PROGRAM_MARK_AS_READY">
              <section>
                <div class="section-items is-small-padding">


                  <el-form-item>
                    <el-col class="el-col--min-25em" :span="16">
                      <el-button
                         type="primary"
                         class="w-100 is-icon"
                        :disabled="!edit"
                        :loading="_get(ProgramDetails, 'saving')"
                        @click="startTransitionNoPayload(TRANSITION_PROGRAM.TRANSITION_PROGRAM_MARK_AS_READY)">
                        {{ $t('label.mark_as_ready') }}
                      </el-button>
                    </el-col>
                  </el-form-item>

                </div>

                <div class="section-help">
                  <p v-html="_markdown.render($t('label.transition_program_template_mark_as_ready_help'))"></p>
                </div>

              </section>
            </el-collapse-item>

            <el-collapse-item
               v-if="_includes(options.availableTransitions, TRANSITION_PROGRAM.TRANSITION_PROGRAM_MARK_AS_DRAFT)"
              :title="$t('label.change_status')"
              :name="TRANSITION_PROGRAM.TRANSITION_PROGRAM_MARK_AS_DRAFT">
              <section>
                <div class="section-items is-small-padding">


                  <el-form-item>
                    <el-col class="el-col--min-25em" :span="16">
                      <el-button
                         type="warning"
                         class="w-100 is-icon"
                        :disabled="!edit"
                        :loading="_get(ProgramDetails, 'saving')"
                        @click="startTransitionNoPayload(TRANSITION_PROGRAM.TRANSITION_PROGRAM_MARK_AS_DRAFT)">
                        {{ $t('label.mark_as_draft') }}
                      </el-button>
                    </el-col>
                  </el-form-item>

                </div>

                <div class="section-help">
                  <p v-html="_markdown.render($t('label.transition_program_template_mark_as_draft_help'))"></p>
                </div>

              </section>
            </el-collapse-item>

          </template>
          <!-- end ~ is template -->

        </el-collapse>

      </el-form>
    </template>


    <template slot="footer">
      <nav class="footer-row is-right">
        <el-button
           type="info"
           size="small"
          :plain="true"
          @click="cancelChanges">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel_the_action') }}</span>
        </el-button>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import moment from 'moment';
import { get, first, invoke, camelCase, includes } from 'lodash';

import { ProgramStateMachine, TRANSITION_PROGRAM } from 'state-machine';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

export default {
  name: 'form-program-change-status',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    ProgramDetails: {
      type: Object,
      required: false,
    },
    PersonOccupiedDates: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    NuttremaGroupAndSort,
    StuffToEatInfoSmallCard,
    NuttremaLayoutFormStandard,
    PopoverQuestionAlert,
  },
  data() {
    return {
      TRANSITION_PROGRAM,
      programStateMachine: null,
      options: {
        selectedTransition: [],
        availableTransitions: [],
        start_date: {
          disabledDate: this.disabledDate,
        },
      },
      formData: {
        message: null,
        start_date: null,
        send_notification: true,
        include_pdf: ['list', 'calendar'],
      },
    };
  },
  methods: {
    disabledDate(time) {
      const inPast = time.getTime() < moment().subtract(1, 'day').toDate();
      const occupiedDates = get(this.PersonOccupiedDates, 'data', []);
      const wasOccupied = includes(occupiedDates, moment(time).format('YYYY-MM-DD'));
      return inPast || wasOccupied;
    },
    setFormData() {
      const status = get(this.ProgramDetails, 'data.status');
      const type = get(this.ProgramDetails, 'data.assigned') ? 'assigned' : 'template';

      // this make sence only for assigned program
      this.formData.start_date = get(this.ProgramDetails, 'data.start_date');

      // init state machine
      this.programStateMachine = ProgramStateMachine(status, type);

      // set available transitions by current status and type of program
      this.setAvailableTransitions();
    },
    resetFormData() {
      this.formData.message = null;
    },
    setAvailableTransitions() {
      const transitions = this.programStateMachine.transitions();
      this.options.selectedTransition = first(transitions);
      this.options.availableTransitions = transitions;
    },
    startTransitionActivatePayload(transition) {
      console.log(transition);

      const data = {
        transition,
        payload: {
          start_date: this.formData.start_date,
          send_notification: this.formData.send_notification,
          message: this.formData.message,
          include_pdf: this.formData.include_pdf,
        },
      };

      this.$emit('transition', data);
      this.resetFormData();
    },
    sendActiveProgramNotification() {
      const payload = {
        message: this.formData.message,
        include_pdf: this.formData.include_pdf,
      };

      this.$emit('sendActiveProgramNotification', payload);
      this.resetFormData();
    },
    startTransitionNotificationPayload(transition) {
      console.log(transition);

      const data = {
        transition,
        payload: {
          send_notification: this.formData.send_notification,
          message: this.formData.message,
        },
      };

      this.$emit('transition', data);
      this.resetFormData();
    },
    startTransitionNoPayload(transition) {
      this.$emit('transition', { transition });
      this.resetFormData();
    },
  },
  computed: {
    endDate() {
      const duration = get(this.ProgramDetails, 'data.duration', 0);
      return moment(this.formData.start_date).add(duration - 1, 'days').toDate();
    },
    isAssigned() {
      return get(this.ProgramDetails, 'data.assigned', false) || false;
    },
  },
  created() {
    this.stateData = this.ProgramDetails;
    this.formRef = 'form-program-change-status';
    this.setFormData();
  },
  watch: {
    'ProgramDetails.transition': {
      handler: function (after, before) {
        try {
          if (after !== before) {
            invoke(this.programStateMachine, camelCase(after));
            this.setAvailableTransitions();
          }
        } catch (error) {
          console.error(error);
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-collapse {
    border-top: none;
    border-bottom: none;

    /deep/ .el-collapse-item {
      .el-collapse-item__header {
        background-color: transparent;
      }
      .el-collapse-item__wrap {
        background-color: transparent;
      }
      &:last-child {
        .el-collapse-item__wrap, .el-collapse-item__header {
          border-bottom: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/settings/status/form-program-change-status.vue